// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6UXR7","col":"styles_col__x0r9o"};